import { render, staticRenderFns } from "./StudentInGroupTable.vue?vue&type=template&id=994566ec"
import script from "./StudentInGroupTable.vue?vue&type=script&lang=js"
export * from "./StudentInGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports